"use strict";
/*
 * Created on 10 11 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var VATConverter_1 = require("./conversions/VATConverter");

var VATConverterImpl_1 = require("./conversions/VATConverterImpl");
/**
 * Configures VAT app module
 *
 * @author JMe
 */


var VATAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(VATAppModule, _AppModule_1$AppModul);

  function VATAppModule() {
    var _this;

    _classCallCheck(this, VATAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VATAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'VATAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(VATAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(VATConverter_1.VATConverter).to(VATConverterImpl_1.VATConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return VATAppModule;
}(AppModule_1.AppModule);

exports.VATAppModule = VATAppModule;